import React from 'react';
import { cn } from '@/lib/utils';

// Spacing between sections lives here, not in the sections, so every gap on a page is the same: 40/48/64px.
export const SectionStack = ({ className, children }) => (
  <div className={cn('flex flex-col gap-10 md:gap-12 lg:gap-16', className)}>
    {children}
  </div>
);
